module.exports = __webpack_public_path__ + "img/Registro.fca97033.png";